export const BUSINESS = {
  name: "MEGAWIN5K",
  category: "Game Store",
  city: "Jakarta",
  addressLine: "Pondok Indah Mall, Jakarta Selatan",
  addressFull: "Pondok Indah Mall, Jakarta Selatan, Indonesia",
  region: "Jakarta Selatan",
  phoneDisplay: "+62 877-8564-2608",
  phoneTel: "+6287785642608",
  reviews: "4,340",
  opens: "09:00",
  busy: "17:00",
  visit: "1.5–4 hours",
  highlight: "goods movement",
  mapsEmbed:
    "https://www.google.com/maps?q=Pondok%20Indah%20Mall%2C%20Jakarta%20Selatan%2C%20Indonesia&output=embed",
  directions: "https://go.site-hoki.top/5dewa",
  callLink: "https://go.site-hoki.top/5dewa",
  reviewsLink:
    "https://www.google.com/search?q=MEGAWIN5K+Pondok+Indah+Mall+Jakarta",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/7862505/pexels-photo-7862505.jpeg",
  exp1: "https://images.pexels.com/photos/16040234/pexels-photo-16040234.jpeg",
  exp2: "https://images.pexels.com/photos/32575377/pexels-photo-32575377.jpeg",
  community: "https://images.unsplash.com/photo-1758410473619-c204b1bcf13a",
  interior: "https://images.unsplash.com/photo-1767839581596-4c3ce952b577",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Games", href: "#experience" },
  { label: "Reviews", href: "#reviews" },
  { label: "Location", href: "#location" },
  { label: "Contact", href: "#contact" },
];
